<template>
    <div>
        <vs-button v-if="$store.state.is_online && $store.state.is_mobile" @click="show_offline=!show_offline" 
            color="primary" size="small" type="filled" class="mb-2 p-2 py-1" style="margin-left: auto;">
            Show {{ show_offline ? "Online" : "Offline" }} Data
        </vs-button>
        <template v-if="$store.state.is_online && !show_offline">
            <OnlineEntryList />
        </template>
        <template v-else>
            <OfflineEntryList />
        </template>
    </div>
</template>

<script>
import OfflineEntryList from './OfflineEntryList.vue';
import OnlineEntryList from './OnlineEntryList.vue';

export default {
    components: {
        OfflineEntryList,
        OnlineEntryList
    },
    data() {
        return {
            show_offline: false
        }
    }
}

</script>